import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatButton } from '@blocks-react/components/Button';
import { CatTableCell } from '@blocks-react/components/TableCell';
import { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
import { BUTTON_VARIANTS } from '@app/constants/commonConstants';

const ShareListRemoveCell = ({
  removeItemfromSelectedList,
  customerOrganizationIdentifier
}) => {
  const [t] = useTranslation();
  return (
    <CatTableCell align="right">
      <CatButton
        variant={BUTTON_VARIANTS.GHOST}
        onClick={() =>
          removeItemfromSelectedList(customerOrganizationIdentifier)
        }
      >
        {t('REMOVE')}
        <CatIconCloseCircle slot="after" />
      </CatButton>
    </CatTableCell>
  );
};

ShareListRemoveCell.propTypes = {
  removeItemfromSelectedList: PropTypes.func,
  customerOrganizationIdentifier: PropTypes.string
};
export default ShareListRemoveCell;
